
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M12.957 24c-6.637 0-12-5.407-12-12 0-6.637 5.363-12 12-12 6.593 0 12 5.363 12 12 0 6.593-5.407 12-12 12z"}}),_c('path',{attrs:{"fill":"#3E529E","fill-rule":"evenodd","d":"M11.067 12.044v6.945a.19.19 0 00.176.176h2.593a.19.19 0 00.176-.176v-7.033h1.89a.19.19 0 00.176-.176l.176-2.11a.19.19 0 00-.176-.175h-2.066V8c0-.352.308-.66.66-.66h1.45a.19.19 0 00.176-.175v-2.11a.19.19 0 00-.176-.176h-2.418a2.57 2.57 0 00-2.593 2.594v2.065H9.836a.19.19 0 00-.176.176v2.11a.19.19 0 00.176.176h1.23v.044z","clip-rule":"evenodd"}})])
          )
        }
      }
    